import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { Modal, ModalBody } from "reactstrap";
import Empty from "../../../base/features/blocks/Empty";
import Spinner from "../../../base/features/micro/Spinner";
import { pricingTerms } from "./services";
import NumberToPersianWord from "number_to_persian_word";
import SimpleLabel from "../../../base/features/micro/SimpleLabel";

class ProductDetailPart2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      termsModal: false,
      selectedShop: null,
    };
  }
  componentDidMount() {
    this.setState({
      selectedShop:
        localStorage.getItem("selected_shop") &&
        JSON.parse(localStorage.getItem("selected_shop")),
    });
  }

  getTerms() {
    pricingTerms().then((items) => {
      items && this.setState({ terms: items });
    });
  }
  render() {
    return (
      <div>
        <div className="row mx-0">
          <div className="col-12 px-0 position-relative">
            <NumberFormat
              dir={this.props.price ? "ltr" : "trl"}
              thousandSeparator
              value={this.props.price}
              onBlur={(e) =>
                e.target.value.replace(/,/gi, "") < 1000
                  ? e.target.classList.add("text-danger")
                  : e.target.classList.remove("text-danger")
              }
              onValueChange={(values) => {
                this.props.priceChange(values.value);
              }}
              className="form-control p-3 rounded14"
              placeholder="قیمت محصول(تومان)*"
            />
            {this.props.price && <SimpleLabel text="قیمت محصول(تومان)*" />}
            {this.props.price && (
              <div className="pt-2 small color-main fw-bold">
                {NumberToPersianWord.convert(this.props.price) + " "} تومان
              </div>
            )}
          </div>
          <div className="col-12 px-0 mt-4 position-relative">
            <NumberFormat
              dir={this.props.payablePrice ? "ltr" : "trl"}
              thousandSeparator
              value={this.props.payablePrice}
              onBlur={(e) =>
                e.target.value.replace(/,/gi, "") < 1000 ||
                this.props.price < this.props.payablePrice
                  ? e.target.classList.add("text-danger")
                  : e.target.classList.remove("text-danger")
              }
              onValueChange={(values) => {
                this.props.payablePriceChange(values.value);
              }}
              className="form-control p-3 rounded14"
              placeholder="قیمت پس از اعمال تخفیف(تومان)"
            />
            {this.props.payablePrice && (
              <SimpleLabel text="قیمت پس از اعمال تخفیف(تومان)" />
            )}
            {this.props.payablePrice && (
              <span className="pt-2 small color-main fw-bold d-inline-block w-50 align-top">
                {NumberToPersianWord.convert(this.props.payablePrice) + " "}{" "}
                تومان
              </span>
            )}
            {this.props.price < this.props.payablePrice && (
              <span className="pt-2 fs-7 text-danger fw-bold d-inline-block w-50">
                قیمت پس از اعمال تخفیف نباید از قیمت محصول بیشتر باشد
              </span>
            )}
          </div>

          <div className="col-12 mt-4 px-3 py-2">
            <div className="row mx-0">
              <div className="col fw-bolder px-0">وضعیت محصول</div>
              <div className="col-auto px-3 align-self-center">
                {this.props.has_stock ? "قابل سفارش" : "غیر قابل سفارش"}
              </div>
              <div className="col-auto px-0 align-self-center">
                <input
                  class="form-check-input mt-0 align-middle color-second"
                  type="checkbox"
                  value={this.props.has_stock}
                  checked={this.props.has_stock}
                  onChange={() =>
                    this.props.has_stock_change(!this.props.has_stock)
                  }
                />
              </div>
            </div>
          </div>
          <div className="col-12 mt-4 px-3 py-2">
            <div className="row mx-0">
              <div className="col fw-bolder px-0">آدرس مشتری برای سفارش</div>
              <div className="col-auto px-3 align-self-center">
                {this.props.need_address ? "نیاز است" : "نیاز نیست"}
              </div>
              <div className="col-auto px-0 align-self-center">
                <input
                  class="form-check-input mt-0 align-middle color-second"
                  type="checkbox"
                  value={this.props.need_address}
                  checked={this.props.need_address}
                  onChange={() =>
                    this.props.need_address_change(!this.props.need_address)
                  }
                />
              </div>
            </div>
          </div>
          <div className="col-12 mt-4 px-3 py-2">
            <div className="row mx-0">
              <div className="col fw-bolder px-0">قابل نمایش برای مشتریان</div>
              <div className="col-auto px-3 align-self-center">
                {this.props.show_on_menu ? "بله" : "خیر"}
              </div>
              <div className="col-auto px-0 align-self-center">
                <input
                  class="form-check-input mt-0 align-middle color-second"
                  type="checkbox"
                  value={this.props.show_on_menu}
                  checked={this.props.show_on_menu}
                  onChange={() =>
                    this.props.show_on_menu_change(!this.props.show_on_menu)
                  }
                />
              </div>
            </div>
          </div>
          <div className="col-12 mt-4 p-3 bg-light-gray rounded14 fw-bold fs-7">
            <span>برای قیمت گذاری محصول به </span>
            <span
              className="color-main"
              onClick={() => {
                this.setState({ termsModal: true });
                this.getTerms();
              }}
            >
              قوانین{" "}
            </span>
            <span>توجه داشته باشید</span>
          </div>
        </div>

        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.state.termsModal}
          toggle={() => this.setState({ termsModal: false })}
        >
          <ModalBody className="row mx-0 p-4">
            {this.state.terms ? (
              <div className="col-12 px-0 py-2">
                {this.state.terms.length === 0 ? (
                  <Empty text={"موردی یافت نشد"} />
                ) : (
                  this.state.terms.map((term, t) => (
                    <div>
                      <h2 className="fw-bold fs-4">{term.title}</h2>
                      <p
                        className="fw-bold text-muted"
                        style={{ whiteSpace: "pre-wrap", lineHeight: "1.7em" }}
                      >
                        {term.des}
                      </p>
                    </div>
                  ))
                )}
              </div>
            ) : (
              <Spinner />
            )}
            <button
              onClick={() => this.setState({ termsModal: false })}
              className="btn rounded28 py-2 w-100 fw-bold bg-color-main text-center text-white"
            >
              متوجه شدم
            </button>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default ProductDetailPart2;
